import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

export const shareHistoryWrapperTemplate = htmlE`
    <div class="h-full is-flex is-flex-direction-column gap-2 py-3">
        <div class="control has-icons-left w-full">
          <span class="icon is-small is-left">
            <i class="icon-search"></i>
          </span>
          <input id="search-share-history" type="search" class="input" data-i18n-key="searchEllipsis" data-i18n-attr-to-update="placeholder" placeholder="Search...">
        </div>

        <div id="share-history-card-wrapper" class="h-full gap-3 is-flex-1 is-flex is-flex-direction-column">
        </div>
    </div>
`;

export const shareHistoryCardTemplate = htmlE`
    <div id="${"id"}" class="px-2 py-1 share-history-card is-flex is-flex-direction-column gap-2">
        <div class="is-flex is-justify-content-space-between">
            <span class="text-xs date-time">${"time"}</span>
            <span class="text-xs passed-time">${"time_diff"}</span>
        </div>
        <div class="shared-files text-xs is-flex is-flex-direction-column gap-1">
            <div class="shared-files-count-wrapper">
                <div class="m-1 shared-files-count">
                    ${"files_count"}
                </div>
            </div>
        </div>
        <div>
            <span class="text-sm share-link">${"url"}</span>
        </div>
        <div class="is-flex action-buttons">
            <button class="remove-button w-full primary-button is-bg-none">
                <i class="icon-trash mr-2 text-accentMain"></i>
                <span data-i18n-key="removeFromLocalHistory">${"removeFromLocalHistoryText"}</span>
            </button>

            <button class="copy-button w-full primary-button is-bg-none">
                <i class="icon-copy mr-2 text-accentMain"></i>
                <span data-i18n-key="Copy">${"CopyText"}</span>
            </button>
        </div>
    </div>
`;

export const shareHistoryFilesCardTemplate = htmlE`
    <p class="shared-item">${"file_name"}</p>
`;
